import React from "react";
import styled from "styled-components";

const Button = styled.button`
  position: absolute;
  left: 0;
  top: 0;
  width: 145px;
  height: 123px;
  display: block;
  background: url(${require("@assets/img/icon_popup_back.png")});
  margin-top: 30px;
  border: 0;
  z-index: 10;

  &.gamePopButton {
    &.in {
      transform: translateX(-160px);
      animation: slideLeftToRight 0.4s;
      animation-delay: 0.5s;
      animation-fill-mode: forwards;
    }
  }
`;

const PopupCloseButton = ({ onClick, cName = "" }) => {
  return (
    <Button
      type="button"
      onClick={onClick}
      className={`popupCloseButton ${cName}`}
    />
  );
};

export default React.memo(PopupCloseButton);
